import React from "react";

import styles from "./style.module.css";

import { Button } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import Select from "react-select";

import numeral from "numeral";
import {
  LineChart,
  Line,
  Scatter,
  CartesianGrid,
  ComposedChart,
  Area,
  CartesianAxis,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  ZAxis,
  ReferenceLine,
  ReferenceDot,
  ReferenceArea,
  ResponsiveContainer,
  ErrorBar,
  Label,
  Cell,
  LabelList
} from "recharts";

import { getRange, getPrettyNumber } from "aible";

import { AutoSizer } from "react-virtualized";

function formatNumber(num) {
  if (num > 1000) {
    return numeral(num).format("0.0a");
  } else if (num > 10) {
    return numeral(num).format("0.[0]");
  } else if (num < 1) {
    return numeral(num).format("0.[0000]");
  } else {
    return numeral(num).format("0.[000]");
  }
}

const CustomToolTip = (props) => {
  const { active, payload, mainKey, referenceKey, mainLabel, referenceLabel } = props;
  if (!active || !payload) {
    return null;
  }

  const dPayload = payload.find((e) => e && e.payload && e.payload.date);
  const date = dPayload && dPayload.payload && dPayload.payload.date;

  return (
    <div className={styles.cTooltip}>
      <div className={styles.tHeader}>{date}</div>
      <div className={styles.toolTipBody}>
        {payload.map((p, i) => {
          if (p.dataKey !== mainKey && p.dataKey !== referenceKey) {
            // return renderRange(p);
            return null;
          }
          const label = p.dataKey === mainKey ? mainLabel : referenceLabel;

          return (
            <div className={styles.dataDriftTooltipItem} key={p.dataKey}>
              <strong className={styles.dataDriftTooltipItemLabel}>{label + ": "}</strong>
              <span className={styles.dataDriftTooltipItemValue}>{numeral(p.value).format("0.[00]") + "%"}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default class DataDrift extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDataDrift: undefined,
      selectedModelMetric: undefined
    };
  }

  renderDataDrift() {
    const { dataDriftWarningThreshold, updateDataDriftWarningThreshold, dataDrift, setupLabels } = this.props;

    const selectedDataDrift = this.state.selectedDataDrift ?? dataDrift?.rankedChanges?.[0];

    const chartData = dataDrift?.monitoringDistributionData?.map((mData) => {
      const sCol = selectedDataDrift?.column;
      const sVal = selectedDataDrift?.value;
      const datasetData = dataDrift?.datasetDistribution?.[sCol]?.[sVal];
      const datasetDataRange = [
        Math.max(0, datasetData - Math.abs(dataDriftWarningThreshold)),
        Math.min(100, datasetData + Math.abs(dataDriftWarningThreshold))
      ];
      const retData = {
        date: mData?.date,
        monitoringData: mData?.data?.[sCol]?.[sVal],
        datasetData: datasetData,
        datasetDataRange: datasetDataRange
      };
      return retData;
    });

    const tableData = dataDrift?.rankedChanges.map((d) => {
      const currData = {
        ...d
      };
      if (selectedDataDrift?.column == currData?.column && selectedDataDrift?.value === currData?.value) {
        currData.isActive = true;
      }
      return currData;
    });
    const tableHeaders = [
      {
        label: "Variable",
        key: "label",
        isLabel: true
      },
      {
        label: "Training Set Distribution",
        key: "datasetDistribution",
        suffix: "%"
      },
      {
        label: "Observed",
        key: "monitoringDistribution",
        suffix: "%"
      },
      {
        label: "% Change",
        key: "change",
        suffix: "%"
      }
    ];

    return (
      <div className={styles.dataDriftSection}>
        <div className={styles.dataDriftHeaderWrapper}>
          <div
            className={styles.dataDriftHeaderItem}
            style={{ marginRight: "auto", width: "unset", textAlign: "left" }}
          >
            <div className={styles.dataDriftSubHeader} style={{ color: "#4B495B" }}>
              {"DATA BEHAVIOR"}
            </div>
            <div className={styles.dataDriftHeader}>{selectedDataDrift?.label}</div>
          </div>
          <div className={styles.dataDriftHeaderItem}>
            <div className={styles.dataDriftHeader}>{selectedDataDrift?.datasetDistribution + "%"}</div>
            <div className={styles.dataDriftSubHeader}>{"TRAINING SET"}</div>
          </div>
          <div className={styles.dataDriftHeaderItem}>
            <div className={styles.dataDriftHeader}>{selectedDataDrift?.monitoringDistribution + "%"}</div>
            <div className={styles.dataDriftSubHeader}>{"OBSERVED"}</div>
          </div>
          <div className={styles.dataDriftHeaderItem}>
            <div className={styles.dataDriftHeader} style={{ color: "#C03E5A" }}>
              {selectedDataDrift?.change + "%"}
            </div>
            <div className={styles.dataDriftSubHeader}>{"CHANGE"}</div>
          </div>
        </div>
        <div className={styles.dataDriftInput}>
          <div className={styles.dataDriftInputText}>
            {"Alert me if the difference between training and observed is greater than"}
          </div>
          <div className={styles.dataDriftInputBox}>
            <LineInput
              isMediumBox
              value={dataDriftWarningThreshold}
              onChange={(val) => updateDataDriftWarningThreshold(val)}
            />
          </div>
          <div className={styles.dataDriftInputText}>{"%"}</div>
        </div>
        <div className={styles.dataDriftChartWrapper}>
          <DriftChart
            data={chartData}
            mainKey={"monitoringData"}
            referenceKey={"datasetData"}
            rangeKey={"datasetDataRange"}
            mainLabel={setupLabels?.outcomeLabel}
            referenceLabel={"Training " + setupLabels?.outcomeLabel}
            isPercentage
          />
        </div>
        <div className={styles.dataDriftTableWrapper}>
          <DriftTable
            data={tableData}
            headers={tableHeaders}
            onClick={(row) =>
              this.setState({
                selectedDataDrift: row
              })
            }
          />
        </div>
      </div>
    );
  }

  renderModelDrift() {
    const {
      modelDriftWarningThreshold,
      updateModelDriftWarningThreshold,
      modelDriftWarningTargets,
      updateModelDriftWarningTargets,
      dataDrift,
      modelDrift,
      setupLabels
    } = this.props;

    const selectedModelMetric = this.state.selectedModelMetric ?? modelDrift?.rankedChanges?.[0];

    const chartData = modelDrift?.monitoringValuesData?.map((mData) => {
      const metricKey = selectedModelMetric?.metric;
      const expectedData = mData?.data?.expected?.[metricKey];
      const warningThresholdRadius = (Math.abs(modelDriftWarningThreshold) / 100) * expectedData;
      const expectedDataRange = [expectedData - warningThresholdRadius, expectedData + warningThresholdRadius];
      const retData = {
        date: mData?.date,
        monitoringData: mData?.data?.monitoring?.[metricKey],
        expectedData: expectedData,
        expectedDataRange: expectedDataRange
      };
      return retData;
    });

    const tableData = modelDrift?.rankedChanges.map((d) => {
      const currData = {
        ...d
      };
      if (selectedModelMetric?.metric == currData?.metric) {
        currData.isActive = true;
      }
      if (modelDriftWarningTargets?.find((t) => t.value === currData?.metric)) {
        currData.isAlert = true;
      }
      return currData;
    });
    const tableHeaders = [
      {
        label: "Metric",
        key: "label",
        isLabel: true
      },
      {
        label: "Expected (At Deployment)",
        key: "expectedValue"
      },
      {
        label: "Actual",
        key: "monitoringValue"
      },
      {
        label: "% Change",
        key: "change",
        suffix: "%"
      }
    ];

    const warningTargetOptions = tableData
      .map((cData) => ({
        label: cData?.label,
        value: cData?.metric
      }))
      .sort((a, b) => {
        return a?.label > b?.label ? 1 : a?.label < b?.label ? -1 : 0;
      });

    return (
      <div className={styles.dataDriftSection}>
        <div className={styles.dataDriftHeaderWrapper}>
          <div
            className={styles.dataDriftHeaderItem}
            style={{ marginRight: "auto", width: "unset", textAlign: "left" }}
          >
            <div className={styles.dataDriftSubHeader} style={{ color: "#4B495B" }}>
              {"MODEL BEHAVIOR"}
            </div>
            <div className={styles.dataDriftHeader}>{selectedModelMetric?.label}</div>
          </div>
          <div className={styles.dataDriftHeaderItem}>
            <div className={styles.dataDriftHeader}>
              {(selectedModelMetric.prefix ?? "") + formatNumber(selectedModelMetric?.expectedValue)}
            </div>
            <div className={styles.dataDriftSubHeader}>{"EXPECTED"}</div>
          </div>
          <div className={styles.dataDriftHeaderItem}>
            <div className={styles.dataDriftHeader}>
              {(selectedModelMetric.prefix ?? "") + formatNumber(selectedModelMetric?.monitoringValue)}
            </div>
            <div className={styles.dataDriftSubHeader}>{"OBSERVED"}</div>
          </div>
          <div className={styles.dataDriftHeaderItem}>
            <div className={styles.dataDriftHeader} style={{ color: "#C03E5A" }}>
              {selectedModelMetric?.change + "%"}
            </div>
            <div className={styles.dataDriftSubHeader}>{"CHANGE"}</div>
          </div>
        </div>
        <div className={styles.dataDriftInput}>
          <div className={styles.dataDriftInputText}>{"Alert me if"}</div>
          <div className={styles.dataDriftInputSelect}>
            <Select
              value={modelDriftWarningTargets}
              onChange={(value) => {
                updateModelDriftWarningTargets(value);
              }}
              options={warningTargetOptions}
              className={styles.outcomePicker}
              placeholder="Select Metric"
              menuPlacement="bottom"
              isMulti
            />
          </div>
          <div className={styles.dataDriftInputText}>{"changes more than"}</div>
          <div className={styles.dataDriftInputBox}>
            <LineInput
              isMediumBox
              value={modelDriftWarningThreshold}
              onChange={(val) => updateModelDriftWarningThreshold(val)}
            />
          </div>
          <div className={styles.dataDriftInputText}>{"%"}</div>
        </div>
        <div className={styles.dataDriftChartWrapper}>
          <DriftChart
            data={chartData}
            mainKey={"monitoringData"}
            referenceKey={"expectedData"}
            rangeKey={"expectedDataRange"}
            mainLabel={"Actual"}
            referenceLabel={"Expected"}
            showLabel
          />
        </div>
        <div className={styles.dataDriftTableWrapper}>
          <DriftTable
            data={tableData}
            headers={tableHeaders}
            onClick={(row) =>
              this.setState({
                selectedModelMetric: row
              })
            }
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.dataDriftWrapper}>
        <div className={styles.dataDriftSectionWrapper}>{this.renderDataDrift()}</div>
        <div className={styles.dataDriftSectionWrapper}>{this.renderModelDrift()}</div>
      </div>
    );
  }
}

class AlertBadge extends React.PureComponent {
  render() {
    const { children } = this.props;
    return (
      <div className={styles.dataDriftBadgeWrapper}>
        <div className={styles.dataDriftBadge}>{children ? children : "ALERT SET"}</div>
      </div>
    );
  }
}

class DriftTable extends React.PureComponent {
  render() {
    const { data, headers, onClick } = this.props;

    return (
      <table className={styles.dataDriftTable}>
        <tr className={styles.dataDriftTableHeaderRow}>
          {headers.map((h) => {
            return (
              <th
                className={styles.dataDriftTableHeaderItem + " " + (h?.isLabel ? styles.isLabel : "")}
                key={"tHeader" + h?.key}
              >
                {h?.label}
              </th>
            );
          })}
        </tr>
        {data.map((d, i) => {
          return (
            <tr
              className={styles.dataDriftTableRow + " " + (d?.isActive ? styles.isActive : "")}
              key={"tRow" + i}
              onClick={() => onClick(d)}
            >
              {headers.map((h) => {
                const dataKey = h?.key;
                const data = h?.isLabel ? d?.[dataKey] : formatNumber(d?.[dataKey]);
                return (
                  <td
                    className={styles.dataDriftTableRowItem + " " + (h?.isLabel ? styles.isLabel : "")}
                    key={"tRowData" + i + "_" + h?.key}
                  >
                    <span>{(d?.prefix && !h?.isLabel && !h?.suffix ? d.prefix : "") + data + (h?.suffix ?? "")}</span>
                    {d?.isAlert && h?.isLabel ? <AlertBadge /> : <React.Fragment />}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </table>
    );
  }
}

class DriftChart extends React.PureComponent {
  render() {
    const { data, mainKey, referenceKey, rangeKey, mainLabel, referenceLabel, isPercentage } = this.props;

    return (
      <AutoSizer>
        {({ width, height }) => (
          <ComposedChart
            data={data}
            margin={{
              top: 30,
              right: 20,
              left: 20,
              bottom: 40
            }}
            width={width}
            height={height}
          >
            <defs>
              <linearGradient id="rangeColor" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#D6CCFF" />
                <stop offset="100%" stopColor="#D6CCFF" />
              </linearGradient>
            </defs>
            <XAxis dataKey="date" name={"Date"}></XAxis>
            <YAxis
              type="number"
              name={mainLabel}
              domain={isPercentage ? [0, 100] : ["auto", "auto"]}
              tickFormatter={(tick) => {
                if (isPercentage) {
                  return tick + "%";
                }
                return tick;
              }}
            ></YAxis>
            <CartesianGrid strokeDasharray="3" vertical={false} />
            <Area type="monotone" dataKey={rangeKey} stroke="url(#rangeColor)" fill="url(#rangeColor)" />
            <Line dataKey={mainKey} dot={false} stroke="#7E69D7" strokeWidth={3} />
            <Line
              type="monotone"
              dataKey={referenceKey}
              dot={false}
              stroke="#7E69D7"
              strokeWidth={3}
              strokeDasharray="5 5"
            />
            <Tooltip
              cursor={{ strokeDasharray: "3 3" }}
              content={
                <CustomToolTip
                  mainLabel={mainLabel}
                  mainKey={mainKey}
                  referenceLabel={referenceLabel}
                  referenceKey={referenceKey}
                />
              }
            />
          </ComposedChart>
        )}
      </AutoSizer>
    );
  }
}
